import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { get_company_details_by_id_action } from "../../../../redux/_actions";
import { useLocation } from "react-router-dom";
function useOverview(props) {
  const location = useLocation();
  const dispatch = useDispatch();

  const [loading , setLoading] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({});

  //get data from redux
  const { companyInformationData } = useSelector(
    (state) => state.get_company_details_by_id_reducer
  );

  useEffect(() => {
    const companyId = location?.state && location.state?.companyId;
    if (companyId) {
      getCompanyInfo(companyId);
    }
  }, []);

  useEffect(() => {
    if (companyInformationData && companyInformationData.data) {
      setCompanyInfo(companyInformationData && companyInformationData.data);
    }
  }, [companyInformationData]);

  const getCompanyInfo = async (id) => {
    setLoading(true);
    await dispatch(get_company_details_by_id_action(id));
    setLoading(false);
  };

  return {
    loading,
    companyInfo,
  };
}
export default useOverview;
